<div>
  <!-- Site Header -->
  <!-- Site Header -->
  @if (header) {
    <div class="flex justify-between items-center mb-4">
      <h3 class="text-gray-600">{{ header }}</h3>
      <div class="flex items-center gap-2">
        <!-- Custom right-side header actions (e.g., toggle, button) -->
        <ng-content select="[header-actions]"></ng-content>
        <!-- Default button, optional -->
        @if (buttonLabel) {
          <p-button
            [label]="buttonLabel"
            class="rounded-md"
            (click)="onButtonClick()">
          </p-button>
        }
      </div>
    </div>
  }

  <!-- Table Controls: Search, Reset -->
  @if (showControls) {
    <div class="bg-white p-4 rounded-t-lg shadow-md">
      <div class="flex justify-between items-center">
        <!-- Search -->
        <div class="relative flex items-center ">
          <i class="pi pi-search absolute left-3 text-gray-400"></i>
          <input
            type="search"
            [(ngModel)]="searchText"
            (ngModelChange)="searchChanged.emit(searchText)"
            pInputText
            [placeholder]="placeholder"
            class="pl-10 min-w-[400px]  pr-4 py-2 border border-gray-300 rounded-2xl focus:outline-none text-sm"
          />
        </div>
        <!-- Reset Button -->
        <div class="flex items-center space-x-4">
          <ng-content select="[table-actions]"></ng-content>
          <p-button
            size="small"
            class="px-4 py-2 rounded-md text-primary bg-white"
            icon="pi pi-refresh"
            label="Reset filter"
            (click)="resetClicked.emit()"
          ></p-button>
        </div>
      </div>
    </div>
  }
  <ng-content></ng-content>
</div>

@if (hasTableWrapper) {
  <div class="p-4 bg-white">
    <ng-content select="[table-wrapper]"></ng-content>
  </div>
}
